export default class PositionPref {
    constructor(play, fragment) {
        this.play = play;
        this.fragment = fragment;
    }

    resolve() {
        return [];
    }
}
